"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ToastTitle", {
    enumerable: true,
    get: function() {
        return ToastTitle;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useToastTitle = require("./useToastTitle");
const _renderToastTitle = require("./renderToastTitle");
const _useToastTitleStylesstyles = require("./useToastTitleStyles.styles");
const ToastTitle = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useToastTitle.useToastTitle_unstable)(props, ref);
    (0, _useToastTitleStylesstyles.useToastTitleStyles_unstable)(state);
    return (0, _renderToastTitle.renderToastTitle_unstable)(state);
});
ToastTitle.displayName = 'ToastTitle';
